export default "__VITE_ASSET__Co0qlha6__"